import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'oldHome',
    meta: {
      title: '案例云',
    },
    redirect: '/home/index',
  },

  {
    path: '/home',
    name: 'Home',
    meta: {
      title: '案例云',
    },
    component: () => import('../layout/home-layout.vue'),
    redirect: '/home/index',
    children: [
      {
        path: 'index',
        name: 'Index',
        component: () => import('../views/index/home.vue'),
        meta: {
          title: '首页',
          saveSrollTop: true,
          keepAlive: true,
          hasBar: true,
        },
      },
      {
        path: '/home/ucenter',
        name: 'Ucenter',
        component: () => import('../views/ucenter'),
        meta: {
          title: '个人中心',
          keepAlive: true,
          hasBar: true,
        },
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/user/loginv2.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/passport',
    name: 'Passport',
    component: () => import('@/views/user/passport.vue'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('../views/index/search.vue'),
    meta: {
      title: '搜索',
      keepAlive: true,
      saveSrollTop: true,
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/user/register.vue'),
    meta: {
      title: '注册',
    },
  },
  {
    path: '/case',
    name: 'Case',
    component: () => import('../layout/index.vue'),
    meta: {
      title: '案例',
    },
    children: [
      {
        path: 'add',
        name: 'CaseAdd',
        component: () => import('../views/case/add.vue'),
        meta: {
          title: '添加案例',
          //saveSrollTop: true,
          //keepAlive: true,
        },
      },
      {
        path: 'list',
        name: 'CaseList',
        component: () => import('../views/case/listByTopic.vue'),
        meta: {
          title: '案例列表',
          saveSrollTop: true,
          keepAlive: true,
        },
      },
      {
        path: 'detail/:id',
        name: 'CaseDetail',
        component: () => import('../views/case/detail.vue'),
        meta: {
          title: '案例详情',
          keepAlive: true,
        },
      },
      {
        path: 'toImg/:id',
        name: 'CaseToImg',
        component: () => import('../views/case/caseToImg.vue'),
        meta: {
          title: '生成图片',
          hideCopyRight: true,
        },
      },
    ],
  },
  {
    path: '/ucenter',
    name: 'Ucenter2',
    component: () => import('../layout/index.vue'),
    meta: {
      title: '我的',
    },
    children: [
      {
        path: 'mypost',
        name: 'Mypost',
        component: () => import('../views/ucenter/mypost.vue'),
        meta: {
          title: '我的帖子',
          saveSrollTop: true,
          keepAlive: true,
        },
      },
      {
        path: 'userpost',
        name: 'Userpost',
        component: () => import('../views/ucenter/mypost.vue'),
        meta: {
          title: '我的帖子',
          keepAlive: true,
          saveSrollTop: true,
        },
      },
      {
        path: 'myPraise',
        name: 'MyPraise',
        component: () => import('../views/ucenter/myPraise.vue'),
        meta: {
          title: '我的点赞',
          keepAlive: true,
          saveSrollTop: true,
        },
      },
      {
        path: 'myAgreement',
        name: 'MyAgreement',
        component: () => import('../views/ucenter/myAgreement.vue'),
        meta: {
          title: '我签署的协议',
          keepAlive: true,
          saveSrollTop: true,
        },
      },
      {
        path: 'userRegister',
        name: 'userRegister',
        component: () => import('../views/ucenter/userRegister.vue'),
        meta: {
          title: '用户注册',
        },
      },
      {
        path: 'resetPwd',
        name: 'ResetPwd',
        component: () => import('../views/ucenter/resetPwd.vue'),
        meta: {
          title: '重设密码',
        },
      },
      {
        path: 'userSetting',
        name: 'UserSetting',
        component: () => import('../views/ucenter/userSetting.vue'),
        meta: {
          title: '用户设置',
        },
      },
      {
        path: 'tenantRegister',
        name: 'TenantRegister',
        component: () => import('../views/ucenter/tenantRegister.vue'),
        meta: {
          title: '注册CEO驾驶舱',
          copyRight: '客户云',
        },
      },
      {
        path: 'tenantApply',
        name: 'TenantApply',
        component: () => import('../views/ucenter/tenantRegister.vue'),
        meta: {
          title: '体验CEO驾驶舱',
          copyRight: '客户云',
        },
      },
      {
        path: 'myTengyucloud',
        name: 'MyTengyucloud',
        component: () => import('../views/ucenter/myTengyucloud.vue'),
        meta: {
          title: '我的CEO驾驶舱',
          copyRight: '客户云',
        },
      },
    ],
  },
  {
    path: '/marketing',
    name: 'Marketing',
    component: () => import('../layout/index.vue'),
    meta: {
      title: '营销',
    },
    children: [
      {
        path: 'channelRegister',
        name: 'ChannelRegister',
        component: () => import('../views/marketing/channelRegister.vue'),
        meta: {
          title: '渠道申请',
          copyRight: '营销云',
        },
      },
      {
        path: 'channel',
        name: 'Channel',
        component: () => import('../views/marketing/channel.vue'),
        meta: {
          title: '渠道管理',
          copyRight: '营销云',
          keepAlive: true,
          saveSrollTop: true,
        },
      },
      {
        path: 'spreed',
        name: 'Spreed',
        // component: () => import('../views/marketing/webviewSprees.vue'),
        component: () => import('../views/marketing/WebSpreed.vue'),
        meta: {
          title: '推广',
          copyRight: '营销云',
          keepAlive: true,
          saveSrollTop: true,
        },
      },
      {
        path: 'couponDetail',
        name: 'CouponDetail',
        component: () => import('../views/marketing/CouponDetail.vue'),
        meta: {
          title: '优惠券',
          copyRight: '营销云',
          keepAlive: true,
          saveSrollTop: true,
        },
      },
      {
        path: 'couponRecive',
        name: 'CouponRecive',
        component: () => import('../views/marketing/CouponRecive.vue'),
        meta: {
          title: '领取优惠券',
          copyRight: '营销云',
        },
      },
      {
        path: 'couponShare',
        name: 'CouponShare',
        component: () => import('../views/marketing/CouponShare.vue'),
        meta: {
          title: '分享优惠券',
          copyRight: '营销云',
          keepAlive: true,
          saveSrollTop: true,
        },
      },
    ],
  },
  {
    path: '/pay',
    name: 'Pay',
    component: () => import('@/views/pay/wxpay.vue'),
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: () => import('@/views/pay/components/agreement.vue'),
  },
  {
    path: '/jump',
    name: 'Jump',
    component: () => import('@/views/Jump.vue'),
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404.vue'),
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/404',
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.saveSrollTop) {
        from.meta.savedPosition =
          document.documentElement.scrollTop || document.body.scrollTop
      }
      return { x: 0, y: to.meta.savedPosition || 0 }
    }
  },
  routes,
})

export default router
